import { getBaseUrl } from "@/lib/getBaseURL";
type MenuItem = {
  id: number;
  documentId: string;
  title: string;
  type: string;
  path: string;
  externalPath: string | null;
  uiRouterKey: string;
  menuAttached: boolean;
  order: number;
  collapsed: boolean;
  additionalFields: Record<string, any>;
  audience: any[];
  autoSync: boolean;
  parent: { id: number } | null;
  items?: MenuItem[];
};

function buildMenuTree(flatList: MenuItem[]): MenuItem[] {
  const idMap: Record<number, MenuItem> = {};
  const rootItems: MenuItem[] = [];

  flatList.forEach((item) => {
    idMap[item.id] = { ...item, items: [] };
  });

  flatList.forEach((item) => {
    if (item.parent?.id) {
      const parent = idMap[item.parent.id];
      if (parent) {
        parent.items!.push(idMap[item.id]);
      }
    } else {
      rootItems.push(idMap[item.id]);
    }
  });

  return rootItems;
}

async function fetchNavigationMenuTree(language: string): Promise<MenuItem[]> {
  // const { language, setLanguage } = useLanguage();
  // const language = "am";
  // try {
  const response = await fetch(
    `${getBaseUrl()}/api/navigation/render/navigation?locale=${language}`
  );
  const data = await response.json();

  // In case the response has a structure like { data: [...] }
  const flatList: MenuItem[] = Array.isArray(data) ? data : data.data;
  return buildMenuTree(flatList);
  // }
  //  catch (error) {
  //   console.error('Failed to fetch navigation menu:', error);
  //   return [];
  // }
}
export { fetchNavigationMenuTree };
